<template>
    <div @click="loginRedirect" :class="classes">
        <!-- <table>
            <tr>
                <td class= "login-text"> -->
                    <span><slot></slot></span>
                <!-- </td>
                <td> -->
                    <span class="helper"></span><svg style="float:right;" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-discord" viewBox="0 0 16 16">
                        <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"></path>
                      </svg>
                <!-- </td>
            </tr>
        </table> -->
    </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'discord-btn',
  props: {
    buttonClass: {
      type: String,
      default: 'discord-btn'
    },
    buttonSelectedClass: {
      type: String,
      default: 'discord-btn-selected'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    loginUrl () {
      return Vue.config.CURRENCY_SERVICE_ROOT_BASE_URL + '/auth/connect/discord?path=' + encodeURIComponent(this.$route.path)
    },
    classes () {
      return {
        [this.buttonClass]: true,
        [this.buttonSelectedClass]: this.selected
      }
    }
  },
  methods: {
    loginRedirect () {
      window.location = this.loginUrl
    }
  }
}
</script>

<style scoped>
    .discord-btn{
    background-color: #02049c;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgba(48, 0, 207, 0.536) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s; 
    }
    .discord-btn:hover{
    background-color: rgb(12, 0, 149);
    }
    .discord-text{
    font-size : 18px;
    padding-right: 5px;
    }
    .discord-img{
    width: 25px;
    vertical-align: middle;
    }
    .helper {
      display: inline-block;
    height: 100%;
    vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/Discord-Btn.vue